<template>
  <div>
    <RegistrationForm
      v-if="step === 'form'"
      :form-data="formData"
      :is-new="true"
      @submit="handleFormSubmit"
    />
    <RegistrationConfirm
      v-else-if="step === 'confirm'"
      :form-data="formData"
      :is-new="true"
      @goBack="step = 'form'"
      @submit="handleConfirmSubmit"
    />
    <RegistrationCompleted
      v-else-if="step === 'completed'"
      :is-subscribed="true"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import RegistrationForm from './_Form'
import RegistrationConfirm from '../shared/Confirm'
import RegistrationCompleted from '../shared/Completed'

export default {
  name: 'EdiRequestSubscribedNew',
  components: { RegistrationForm, RegistrationConfirm, RegistrationCompleted },
  data() {
    return {
      step: 'form',
      formData: null
    }
  },
  watch: {
    step() {
      this.$nextTick(() => {
        this.scrollToTop()
      })
    }
  },
  created() {
    this.fetchInitialData()
  },
  methods: {
    ...mapActions('EdiRequestSubscribed', {
      fetchNew: 'new',
      createSubscribed: 'create',
    }),
    fetchInitialData() {
      const token = this.$route.params.token
      this.fetchNew({ token }).then(content => {
        // APIから取得したデータをformDataに設定
        this.formData = {
          id: content.id,
          jwnet_name: content.jwnet_name,
          corporation_code: content.corporation_code,
          corporate_designation_type: content.corporate_designation_type,
          emission_name: content.emission_name,
          emission_name_kana: content.emission_name_kana,
          zip_code: content.zip_code,
          prefecture_code: content.prefecture_code,
          address_1: content.address_1,
          address_2: content.address_2,
          address_3: content.address_3,
          contact_last_name: content.contact_last_name,
          contact_first_name: content.contact_first_name,
          contact_last_name_kana: content.contact_last_name_kana,
          contact_first_name_kana: content.contact_first_name_kana,
          email: content.email,
          transport_name: content.transport_name,
          phone_number: content.phone_number,
          jwnet_pricing_type: content.jwnet_pricing_type,
          subscriber_number: content.subscriber_number,
          edi_usage_key: content.edi_usage_key,
          terms_of_edi_request: content.terms_of_edi_request,
        }
      })
    },
    handleFormSubmit(formData) {
      this.formData = formData
      this.step = 'confirm'
    },
    handleConfirmSubmit() {
      const token = this.$route.params.token
      const payload = {
        emission_request: this.formData
      }
      this.createSubscribed({ token, data: payload }).then(() => {
        this.step = 'completed'
      }).catch(error => {
        console.error('申請の送信に失敗しました', error)
      })
    },
    scrollToTop() {
      const targets = [
        document.scrollingElement,
        document.documentElement,
        document.body,
        document.querySelector('.v-main__wrap'),
        document.querySelector('.v-application--wrap')
      ]

      targets.forEach(target => {
        if (!target) return
        if (typeof target.scrollTo === 'function') {
          target.scrollTo(0, 0)
        }
        target.scrollTop = 0
      })
    }
  }
}
</script>
